<template>
  <page-view :title="false">
    <a-card :bordered="false">
      <a-descriptions>
        <template slot="title">
          <span>基础信息</span>
          <a-button style="margin-left: 20px;" type="primary" @click="back"
            >返回列表</a-button
          >
        </template>
        <a-descriptions-item label="服务标识">
          {{ routeQuery.code }}
        </a-descriptions-item>
        <a-descriptions-item label="服务名称">
          {{ routeQuery.descript }}
        </a-descriptions-item>
        <a-descriptions-item label="服务id">
          {{ routeQuery.serviceId }}
        </a-descriptions-item>
        <a-descriptions-item label="服务url">
          {{ routeQuery.url }}
        </a-descriptions-item>
        <a-descriptions-item label="匹配路径">
          {{ routeQuery.route }}
        </a-descriptions-item>
      </a-descriptions>
      <a-descriptions
        title="服务接口列表"
        style="margin-top: 20px;"
      ></a-descriptions>
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="api路径"
                ><a-input v-model="queryParam.apiUrl" placeholder="api路径"
              /></a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="是否停用">
                <a-select
                  v-model="queryParam.isHalt"
                  placeholder="请选择"
                  allowClear
                >
                  <a-select-option value="F">正常</a-select-option>
                  <a-select-option value="T">停用</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced"> </template>
            <a-col :md="(!advanced && 8) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="
                  (advanced && { float: 'right', overflow: 'hidden' }) || {}
                "
              >
                <a-button type="primary" @click="$refs.table.refresh(true)"
                  >查询</a-button
                >
                <a-button class="button-margin-left" @click="rest"
                  >重置</a-button
                >
                <a-button
                  class="button-margin-left"
                  type="primary"
                  icon="plus"
                  v-hasAnyPermission="`service:add_api`"
                  @click="add"
                  >新建</a-button
                >
                <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? "收起" : "展开" }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 数据表格 -->
      <s-table
        ref="table"
        rowKey="id"
        :columns="columns"
        :data="loadData"
        showPagination="auto"
        :scroll="{ x: 2000 }"
      >
        <span slot="tagItem" slot-scope="text, record">
          <template>
            {{ text }}
            <a-tag class="render-tag" color="grey" v-if="record.isHalt == 'T'"
              >已停用</a-tag
            >
          </template>
        </span>
        <span slot="tagCheck" slot-scope="text">
          <template>
            <a-tag
              class="render-tag"
              :color="text == 'T' ? '#108ee9' : 'grey'"
              >{{ text == "T" ? "校验" : "不校验" }}</a-tag
            >
          </template>
        </span>
        <span slot="action" slot-scope="text, record">
          <template>
            <a
              class="a-action"
              @click="action(record, 'edit')"
              v-hasAnyPermission="`service:edit_api`"
              >编辑</a
            >

            <a-popconfirm
              title="确认删除?"
              @confirm="action(record, 'del')"
              okText="确认"
              cancelText="取消"
              v-hasAnyPermission="`service:delete_api`"
              ><a class="a-action">删除</a></a-popconfirm
            >
          </template>
        </span>
      </s-table>
    </a-card>

    <system-service-api-info
      ref="info"
      :serviceCode="routeQuery.code"
      @success="$refs.table.refresh(true)"
    ></system-service-api-info>
  </page-view>
</template>

<script>
import moment from "moment";
import { STable } from "@/components";
import { PageView } from "@/layouts";
import SystemServiceApiInfo from "./SystemServiceApiInfo.vue";

export default {
  name: "SystemServiceApiList",
  components: {
    STable,
    PageView,
    SystemServiceApiInfo
  },
  data() {
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      routeQuery: {},
      // 查询参数
      queryParam: {
        serviceCode: "",
        sort: "list_order"
      },
      // 表头
      columns: [
        {
          title: "api名称",
          dataIndex: "apiName",
          fixed: "left",
          width: 280
        },
        {
          title: "api路径",
          dataIndex: "apiUrl",
          scopedSlots: { customRender: "tagItem" },
          fixed: "left",
          width: 280
        },
        {
          title: "是否校验登录",
          dataIndex: "isCheckLogin",
          scopedSlots: { customRender: "tagCheck" },
          fixed: "left",
          width: 120
        },
        {
          title: "备注",
          dataIndex: "remark"
        },
        {
          title: "排序",
          dataIndex: "listOrder",
          width: 100
        },
        {
          title: "操作人",
          dataIndex: "modifyUser",
          width: 120
        },
        {
          title: "更新时间",
          dataIndex: "modifyDatetime",
          width: 200
        },
        {
          title: "操作",
          dataIndex: "action",
          align: "left",
          fixed: "right",
          width: 180,
          scopedSlots: { customRender: "action" }
        }
      ],
      //加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return this.$http.systemBksApi
          .pageSystemServiceApi(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.resultObject;
          });
      }
    };
  },
  created() {
    this.routeQuery = this.$route.query;
    this.queryParam.serviceCode = this.routeQuery.code;
  },
  methods: {
    back() {
      this.$router.push({
        name: "SystemServiceList"
      });
    },
    /**
     * 操作
     * @param {Object} record
     * @param {Object} type
     */
    action(record, type) {
      if (type == "edit") {
        this.$refs.info.showModal(type, Object.assign({}, record));
      } else if (type == "del") {
        this.$http.systemBksApi
          .removeSystemServiceApiById({ id: record.id })
          .then(res => {
            if (res.result == 0) {
              this.$refs.table.refresh(true);
              this.$message.success(res.msg);
            }
          });
      } else if (type == "api") {
        // console.log("api");
      }
    },
    add() {
      this.$refs.info.showModal("add", null);
    },
    /**
     * 展开/收起查询条件
     */
    toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    rest() {
      this.queryParam = {
        sort: "list_order"
      };
      this.queryParam.serviceCode = this.routeQuery.code;
    }
  }
};
</script>
